import { StorageReference } from '@angular/fire/storage';
import { FileExtra } from '@ih/app/client/shared/interfaces';

export class ConfirmZipAction {
  public static readonly type = '[Project/Storage/List] ConfirmZipAction';
  constructor(public readonly file: StorageReference & FileExtra) {}
}
